import { LuTrash2 } from "react-icons/lu";

const JOIN_LABEL = { if: "IF", elseIf: "ELSE IF", else: "ELSE" };

const ordered = (rules) => {
    const lines = rules.filter((rule) => rule.join !== "else");
    const fallback = rules.find((rule) => rule.join === "else");
    return fallback ? [...lines, fallback] : lines;
};

const RuleLines = ({ rules = [], onChange, readOnly }) => {
    const lines = ordered(rules);
    const write = (index, field, value) => {
        if (lines[index]?.[field] === value) return;
        onChange(lines.map((rule, ruleIndex) => (ruleIndex === index ? { ...rule, [field]: value } : rule)));
    };
    const add = (join) => {
        if (!lines.length) {
            onChange([{ join: "if", when: "", then: "" }]);
            return;
        }
        onChange(ordered([...lines, join === "else" ? { join, then: "" } : { join, when: "", then: "" }]));
    };
    const remove = (index) => {
        const next = lines.filter((_, ruleIndex) => ruleIndex !== index);
        if (next.length && next[0].join !== "if") next[0] = { ...next[0], join: "if", when: next[0].when || "" };
        onChange(next);
    };
    return (
        <div className="internal-work__rules">
            {lines.map((rule, index) => {
                const join = index === 0 ? "if" : rule.join;
                return (
                    <div className={`internal-work__rule${join === "else" ? " is-else" : ""}`} key={`${join}-${index}`}>
                        <b>{JOIN_LABEL[join]}</b>
                        {join === "else" ? null : (
                            <input
                                key={`when-${rule.when || ""}`}
                                type="text"
                                readOnly={readOnly}
                                aria-label={`${JOIN_LABEL[join]} condition`}
                                placeholder="Condition"
                                defaultValue={rule.when || ""}
                                onBlur={(event) => write(index, "when", event.target.value.trim())}
                            />
                        )}
                        {join === "else" ? null : <b>THEN</b>}
                        <input
                            key={`then-${rule.then || ""}`}
                            type="text"
                            readOnly={readOnly}
                            aria-label={`${JOIN_LABEL[join]} result`}
                            placeholder="Result"
                            defaultValue={rule.then || ""}
                            onBlur={(event) => write(index, "then", event.target.value.trim())}
                        />
                        {readOnly ? <span /> : (
                            <button
                                type="button"
                                className="internal-work__icon is-danger"
                                aria-label={`Remove ${JOIN_LABEL[join]}`}
                                onClick={() => remove(index)}
                            >
                                <LuTrash2 />
                            </button>
                        )}
                    </div>
                );
            })}
            {!readOnly && (
                <div className="internal-work__rule-add">
                    {!lines.length ? (
                        <button type="button" onClick={() => add("if")}>Add if</button>
                    ) : (
                        <>
                            <button type="button" onClick={() => add("elseIf")}>Add else if</button>
                            {lines.some((rule) => rule.join === "else") ? null : (
                                <button type="button" onClick={() => add("else")}>Add else</button>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default RuleLines;
